<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <div>
        <v-card class="ma-3 pa-1">
            <Title title="苗の履歴">
                <v-spacer />
                <TitleButton
                    icon="mdi-close"
                    name="戻る"
                    @click="$emit('onCloseGenerationDiagram')" />
            </Title>
            <vue-mermaid
                :config="config"
                :nodes="nodes"
                type="graph TD"
                @nodeClick="onClickNode" />
        </v-card>
    </div>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import TitleButton from '@/components/tools/TitleBarButton';
    import Confirm from '@/components/tools/ConfirmDialog';
    import Title from '@/components/seedling/items/TitleBar'

    export default {
        components: {
            Title,
            TitleButton,
            Confirm
        },
        props: {
            places: {
                type: Array,
                default: []
            },
            targetSeedling: {
                type: Object,
                default: null
            }
        },
        computed: {
            userUID: function () {
                return this.$store.getters["userUID"]
            }
        },
        data: function () {
            return {
                // nodes: [
                //     {
                //         id: "1",
                //         text: "A",
                //         link: "---",
                //         next: ["2"],
                //         editable: true,
                //         style: "fill:#f9f,stroke:#333,stroke-width:4px"
                //     },
                //     { id: "2", text: "B", edgeType: "circle", next: ["3"], editable: true },
                //     { id: "3", text: "C", next: ["4", "6"] , editable: true},
                //     { id: "4", text: "D", link: "-- This is the text ---", next: ["5"], editable: true },
                //     { id: "5", text: "E" , editable: true},
                //     { id: "6", text: "F" , editable: true}
                // ],                
                // nodes: [
                //     { id: "3", text: "C", next: ["4", "6"], group: "two" , editable: true},
                //     {
                //         id: "1",
                //         text: "A",
                //         link: "---",
                //         next: ["2"],
                //         group: "two", editable: true
                //     },
                //     {
                //         id: "4",
                //         text: "D",
                //         link: "-- This is the text ---",
                //         next: ["5"],
                //         group: "two", editable: true
                //     },
                //     { id: "5", text: "E", group: "three" , editable: true},
                //     { id: "2", text: "B", edgeType: "circle", next: ["3"], group: "one" , editable: true},
                //     { id: "6", text: "F", group: "three", editable: true }
                // ],
                config: {
                    theme: "forest", //"neutral", //"default",
                    startOnLoad: false,
                    securityLevel: 'loose',                    
                },
                nodes: []
            }
        },
        created: function () {
            // return
            console.log("diagram create")
            this.nodes = []
            const items = []
            this.setNodeItems(
                items, 
                {
                    seedlingID: this.targetSeedling.body.seedlingID, 
                    placeInformation: null
                }
            )
            console.log(items)
        },
        methods: {
            onClickNode: function (nodeID) {
                console.log("onClickNode", nodeID)
            },
            // target: {
            //     seedlingID:
            //     placeInformation: {
            //         place:
            //         date:
            //     }
            // }
            setNodeItems: async function (items, target, isRoot) {
                console.log("setNodeItems", items, target)
                const self = this
                await db.collection("users").doc(this.userUID).collection("seedlings").doc(target.seedlingID).get().then(async function(doc){
                    
                    const seedling = doc.data()
                    
                    if (seedling != null) {
                        var startHistoryIndex = null
                        if (target.placeInformation == null) {
                            startHistoryIndex = seedling.placeHistories.length - 1
                        } else {
                            startHistoryIndex = seedling.placeHistories.findIndex((v)=>v.place == target.placeInformation.place && v.date == target.placeInformation.date)
                            if (startHistoryIndex < 0) {
                                console.log("place history not found!!", target)
                            }
                        }
                        for (var index=startHistoryIndex; index>=0; index--) {
                            const history = seedling.placeHistories[index]
                            history.placeName = self.place(history.place).name
                            const item = {
                                seedling: seedling,
                                placeInformation: history,
                                harvests: [],
                                nextList: [],
                                node: null
                            }
                            items.push(item)
                        }
                        // 親苗を取得
                        if (seedling.parentSeedling.seedlingID != '') {
                            await self.setNodeItems(
                                items, 
                                {
                                    seedlingID: seedling.parentSeedling.seedlingID,
                                    placeInformation: {
                                        place: seedling.parentSeedling.place,
                                        date: seedling.parentSeedling.date
                                    }
                                },
                                false
                            )
                        }
                    } else {
                        console.log("unknown seedling!!", target.seedlingID)
                    }

                    if (isRoot == null || isRoot == true) {
                        self.completedNodeSet(items)
                    }
                })
            },
            completedNodeSet: function (items) {
                console.log("completedNodeSet", items)

                // ==========================
                // 作成したノードのデータを日付の昇順に並び替え
                items.sort(function(a, b) {
                    if (a.placeInformation.date > b.placeInformation.date) {
                        return 1
                    }
                    if (a.placeInformation.date < b.placeInformation.date) {
                        return -1
                    }
                    if (a.placeInformation.dateTime > b.placeInformation.dateTime) {
                        return 1
                    }
                    if (a.placeInformation.dateTime < b.placeInformation.dateTime) {
                        return -1
                    }
                    return 0
                })
                console.log("sorted items", items)

                // ==========================
                // 次への参照をセット
                for (var i=0; i<items.length-1; i++) {
                    const item = items[i]
                    item.nextList.push(items[i+1])
                }
                // ==========================
                // ノードを作成
                const self = this

                items.forEach(function(item) {
                    const id = self.nodes.length + 1
                    const node = {
                        id: ""+id,
                        text: "\"" + item.placeInformation.placeName + "<br/>" + item.seedling.name + "\"",
                        link: [],
                        next: [],
                        editable: true,
                        item: item
                    }
                    if (item.nextList.length > 0) {
                        var work = ""
                        switch (item.nextList[0].placeInformation.type) {
                            case 1:
                                work = "採苗"
                                break;
                            case 2:
                                work = "定植"
                                break;
                            case 3:
                                work = "移動"
                                break;
                            case 99:
                                work = "廃棄"
                                break;                                
                        }
                        node.link.push("-- " + "\"" + work + "(" + item.nextList[0].placeInformation.date + ")" + "\"" + " -->")
                        node.next.push(""+(id+1))
                    }
                    console.log("create node", node)
                    self.nodes.push(node)
                })
            },


            //                     id: ""+id,
            //                     text: "\"" + self.place(item.place).name + "\"" + "<br/>" + item.seedling.name + "<br/>" + item.date,
            //                     // group: self.place(item.place).name,
            //                     link: "",
            //                     editable: true,
            //                     item: item






            // // aaa: function () {
            // //     document.querySelector("meta[name='viewport']").setAttribute('content', "width=device-width, initial-scale=0.7")
            // // },
            // editNode(nodeId) {
            //     const self = this
            //     const userUID = this.$store.getters["userUID"]

            //     // ==================
            //     // ノード取得
            //     const index = this.nodes.findIndex((v)=>v.id === nodeId)
            //     const node = this.nodes[index]

            //     // ==================
            //     // ノードに設定されているitemを取得
            //     const item = node.item

            //     console.log("editNode", nodeId, node)

            //     if (item.setChildren == true) {
            //         return
            //     }
            //     item.setChildren = true

            //     // ==================
            //     // ノードの苗を取得
            //     const seedling = node.item.seedling

            //     console.log("editNode", item)

            //     this.createNode(
            //         {
            //             seedling: seedling,
            //             place: item.place,
            //             date: item.date
            //         }, 
            //         2, 
            //         node)
            // },
            // // ====================================
            // // 指定された苗からのノードを作成
            // // target: {
            // //     seedling:
            // //     place:
            // //     date:
            // // }
            // // mode:1(この苗までの履歴を取得, 2:この苗からの履歴)
            // // parentNode: 作成したノードをセットするノード
            // createNode: async function (target, mode, parentNode) {
           
            //     console.log("createNode", target, mode, parentNode)

            //     this.$store.commit("processing", {start:true, message:"データ収集中です。"})

            //     try {
            //         const self = this
            //         const items = []

            //         // フロー表示用のデータ作成            
            //         var finisher = function () {
            //             console.log(items)

            //             items.sort(function(a, b){
            //                 if (a.dateTime < b.dateTime) {
            //                     return -1
            //                 }
            //                 if (a.dateTime > b.dateTime) {
            //                     return 1
            //                 }
            //                 return 0
            //             })
            //             console.log("sorted", items)

            //             // フロー表示用のデータ作成
            //             var id = self.nodes.length + 1
            //             const startID = id

            //             for(var i=0; i<items.length; i++) {
            //                 const item = items[i]
            //                 var node = {
            //                     id: ""+id,
            //                     text: "\"" + self.place(item.place).name + "\"" + "<br/>" + item.seedling.name + "<br/>" + item.date,
            //                     // group: self.place(item.place).name,
            //                     link: "",
            //                     editable: true,
            //                     item: item
            //                 }
            //                 self.nodes.push(node)

            //                 switch (item.type) {
            //                     case "move": 
            //                         node.text += "<br/>移動"
            //                         break;
            //                     case "start": 
            //                         node.text += "<br/>採苗"
            //                         break;
            //                     case "planting": 
            //                         node.text += "<br/>定植"
            //                         break;
            //                     case "discard": 
            //                         node.text += "<br/>廃棄"
            //                         break;
            //                 }
            //                 if (i < items.length - 1) {
            //                     // 次のノードが存在する時は、next にidをセット
            //                     node.next = [""+(id+1)]
            //                 } else {
            //                     // 次のノードが存在しない時で、かつparentNodeがnull(=ノードがクリックされた時ではない時)の時は、枠を強調
            //                     if (parentNode == null) {
            //                         node.style = "stroke-width:4px"
            //                     }
            //                 }
            //                 console.log("finisher create node", node)

            //                 // if (i > 0) {
            //                 //     node.next = [id-1]
            //                 // }
            //                 id++
            //             }
            //             if (items.length > 0 && parentNode != null) {
            //                 if (parentNode.next == null) {
            //                     parentNode.next = [""+startID]
            //                     console.log("finisher parent node next create", parentNode.next)
            //                 } else {
            //                     parentNode.next.push(""+startID)
            //                     console.log("finisher parent node next add", parentNode.next)
            //                 }
            //             }
            //             console.log(self.nodes)

            //             self.$store.commit("processing")
            //         }

            //         switch (mode) {
            //             case 1:
            //                 await this.setNodeToParent(
            //                     items, 
            //                     {
            //                         seedling: target.seedling, 
            //                         place: target.place,
            //                         date: target.date,
            //                     },
            //                     finisher)
            //                 break;
            //             case 2:
            //                 await this.setNodeToChild(
            //                     items, 
            //                     {
            //                         seedling: target.seedling, 
            //                         place: target.place,
            //                         date: target.date,
            //                     },
            //                     parentNode,
            //                     finisher)
            //                 break;
            //         }

            //     } catch (error) {
            //         console.log(error)
            //         this.$store.commit("processing")
            //     }
            // },
            // // =======================================================
            // // 指定された苗から親苗を辿ってノードをセット
            // // items: バッファ
            // // target: { ... ノードにセットする対象
            // //     seedling:
            // //     place:
            // //     date:
            // // }
            // // finisher: 処理終了後に呼び出すコールバック先(再帰呼び出し時は、null)
            // setNodeToParent: async function (items, target, finisher) {
            //     console.log("setNodeToParent", target, finisher)
            //     const self = this
            //     const userUID = this.$store.getters["userUID"]
            //     await db.collection("users").doc(userUID).collection("seedlings").doc(target.seedling.seedlingID).get().then(async function(doc){
            //         const seedling = doc.data()
            //         if (seedling != null) {
            //             // 移動履歴からtargetで指定された場所と日付のインデックスを取得
            //             const historyIndex = seedling.placeHistories.findIndex((v)=>v.place == target.place && v.date == target.date)

            //             // 取得したインデックス以前の移動履歴を取得(正確には0～取得したインデックスまで)して、ノードを作成(インデックスより後の履歴は無視)
            //             for(var i=0; i<=historyIndex; i++) {
            //                 const history = seedling.placeHistories[i]
            //                 var item = {
            //                     seedling: seedling,
            //                     date: history.date,
            //                     dateTime: history.dateTime,
            //                     place: history.place,
            //                     type: "",
            //                     setChildren: false  // このノードの全ての"子苗"のノードが表示されているか否か
            //                 }
            //                 switch (history.type) {
            //                     case 1: 
            //                         item.type = "start"
            //                         break;
            //                     case 2: 
            //                         item.type = "planting"
            //                         break;
            //                     case 3: 
            //                         item.type = "move"
            //                         break;
            //                     case 99: 
            //                         item.type = "discard"
            //                         break;
            //                 }
            //                 items.push(item)
            //             }
            //             // 親
            //             if (seedling.parentSeedling.seedlingID != '') {
            //                 await self.setNodeToParent(
            //                     items,
            //                     {
            //                         seedling: seedling.parentSeedling, 
            //                         place: seedling.parentSeedling.place,
            //                         date: seedling.parentSeedling.date
            //                     },
            //                     null)
            //             }
            //         }
            //         // 終了
            //         if (finisher != null) {
            //             console.log("call finisher", target, items)
            //             finisher()
            //         }
            //     })
            // },
            // // =======================================================
            // // 指定された苗から場所を辿ってノードをセットと、全ての子をノードをセット
            // // ex.苗の場所が A -> B -> C と移動している時、B のノードがクリックされた時は、C の場所のノードをセットする
            // setNodeToChild: async function (items, target, parentNode, finisher) {
            //     console.log("setNodeToChild", target, parentNode, finisher)
            //     const self = this
            //     const userUID = this.$store.getters["userUID"]

            //     const seedling = target.seedling
            //     const historyIndex = seedling.placeHistories.findIndex((v)=>v.place == target.place && v.date == target.date)

            //     // 取得したインデックスの次の位置から最後までのノードを作成
            //     for(var i=historyIndex+1; i<seedling.placeHistories.length; i++) {
            //         const history = seedling.placeHistories[i]
                    
            //         if (self.nodes.findIndex((v)=>v.item.seedling.seedlingID == seedling.seedlingID && v.item.date == history.date && v.item.place == history.place) < 0) {
            //             var item = {
            //                 seedling: seedling,
            //                 date: history.date,
            //                 dateTime: history.dateTime,
            //                 place: history.place,
            //                 type: "",
            //                 setChildren: false  // このノードの全ての"子苗"のノードが表示されているか否か
            //             }
            //             switch (history.type) {
            //                 case 1: 
            //                     item.type = "start"
            //                     break;
            //                 case 2: 
            //                     item.type = "planting"
            //                     break;
            //                 case 3: 
            //                     item.type = "move"
            //                     break;
            //                 case 99: 
            //                     item.type = "discard"
            //                     break;
            //             }
            //             items.push(item)
            //         } else {
            //             console.log("sedNodeToChild", "skip")
            //         }
            //     }

            //     // 子
            //     await db.collection("users").doc(userUID).collection("seedlings")
            //           .where("parentSeedling.seedlingID", "==", target.seedling.seedlingID)
            //           .where("parentSeedling.place", "==", target.place)
            //           .where("parentSeedling.date", "==", target.date).get().then(async function(snapShot){
                    
            //         var id = self.nodes.length + 1

            //         for (var i = 0; i < snapShot.size; i++) {

            //             const seedling = snapShot.docs[i].data()
            //             const history = seedling.placeHistories[0]

            //             if (self.nodes.findIndex((v)=>v.item.seedling.seedlingID == seedling.seedlingID && v.item.date == history.date && v.item.place == history.place) < 0) {
            //                 var item = {
            //                     seedling: seedling,
            //                     date: history.date,
            //                     dateTime: history.dateTime,
            //                     place: history.place,
            //                     type: "start",
            //                     setChildren: false  // このノードの全ての"子苗"のノードが表示されているか否か
            //                 }

            //                 var node = {
            //                     id: ""+id,
            //                     text: "*"+id+"*"+self.place(item.place).name + "<br/>" + item.seedling.name + "<br/>" + item.date + "<br/>採苗",
            //                     // group: self.place(item.place).name,
            //                     link: "",
            //                     editable: true,
            //                     item: item,
            //                 }
            //                 self.nodes.push(node)
                            
            //                 if (parentNode.next == null) {
            //                     parentNode.next = [node.id]
            //                     console.log("setNodeToChild parent node next create", parentNode.next)
            //                 } else {
            //                     parentNode.next.push(node.id)
            //                     console.log("setNodeToChild parent node next add", parentNode.next)
            //                 }

            //                 console.log("setNodeToChild create child node", node)

            //                 id++
            //             }
            //         }

            //         // 収穫物
            //         if (parentNode.item.type == 'planting') {
            //             await db.collection("users").doc(userUID).collection("seedlings").doc(target.seedling.seedlingID).collection("harvests").get().then(function(snapShot){

            //                 for (var i = 0; i < snapShot.size; i++) {
            //                     const harvest = snapShot.docs[i].data()
            //                     var node = {
            //                         id: ""+id,
            //                         text: "収穫物-"+harvest.harvestNo,
            //                         link: "",
            //                         edgeType: "circle",
            //                         editable: false,
            //                     }
            //                     self.nodes.push(node)

            //                     if (parentNode.next == null) {
            //                         parentNode.next = [node.id]
            //                         // console.log("setNodeToChild parent node next create", parentNode.next)
            //                     } else {
            //                         parentNode.next.push(node.id)
            //                         // console.log("setNodeToChild parent node next add", parentNode.next)
            //                     }

            //                     id++
            //                 }
            //             })
            //         }

            //         // 終了
            //         if (finisher != null) {
            //             console.log("call finisher", target, items)
            //             finisher()
            //         }
            //     })
            // },
            place: function (placeID) {
                const index = this.places.findIndex((v)=>v.placeID === placeID)
                return this.places[index]
            },
        }
    }
</script>
